import { gql } from "@apollo/client";

export default gql`
  mutation ArchiveProject($projectId: ObjectId!) {
    archiveProject(projectId: $projectId)
  }
`;
